import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { STPButton } from './Botones';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CelebrationIcon from '@mui/icons-material/Celebration';

export default function ComingSoonModal({ open, onClose, message }) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" PaperProps={{
      sx: {
        borderRadius: 4,
        overflow: 'hidden',
        background: 'linear-gradient(135deg, #50A579 0%, #97D9AD 100%)',
        boxShadow: 8
      }
    }}>
      <DialogTitle sx={{ backgroundColor: 'rgba(80,165,121,0.95)', color: 'white', textAlign: 'center', fontSize: 32, fontWeight: 700, letterSpacing: 1 }}>
        <CelebrationIcon sx={{ fontSize: 60, color: '#FFD700', mb: -1, animation: 'spin 2s linear infinite' }} />
        <br />
        {t('comingSoon.title', 'Próximamente')}
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', background: 'linear-gradient(135deg, #e8f5e9 0%, #ffffff 100%)', py: 4 }}>
        <Typography sx={{ marginTop: 2, marginBottom: 2, color: '#333', fontWeight: 700, textAlign: 'center', fontSize: 24, lineHeight: 1.2 }}>
          {message || t('comingSoon.message', 'Esta funcionalidad estará disponible próximamente.')}
        </Typography>
        <Typography sx={{ color: '#50A579', fontWeight: 500, textAlign: 'center', fontSize: 18, mt: 2, mb: 1 }}>
          {t('comingSoon.expect', '¡Estamos preparando algo increíble para ti!')}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ backgroundColor: '#e8f5e9', justifyContent: 'center', py: 3 }}>
        <STPButton onClick={onClose} sx={{ '&:hover': { background: 'linear-gradient(90deg, #388e5c 60%, #97D9AD 100%)' } }}>{t('comingSoon.close', 'Cerrar')}</STPButton>
      </DialogActions>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(-10deg); }
          50% { transform: rotate(10deg) scale(1.1); }
          100% { transform: rotate(-10deg); }
        }
      `}</style>
    </Dialog>
  );
}

ComingSoonModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  message: PropTypes.string
}; 